import { createContext, useContext } from 'react';

const DocArchivedContext = createContext(null);

export function useDocArchived() {
  return useContext(DocArchivedContext);
}

export default DocArchivedContext;
